import { CLIENT_LIST_FAIL, CLIENT_LIST_REQUEST, CLIENT_LIST_SUCCESS } from "../constats/client.constant";

export const clientListReducer = (state={}, action) => {
    switch (action.type) {
        case CLIENT_LIST_REQUEST:
            return {
                loading: true
            };
        case CLIENT_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case CLIENT_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}